/**
 * @generated SignedSource<<fc1a2a6839465a5819791cc699796261>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowReturns_item$data = {
  readonly returnPolicy?: {
    readonly returnDays: number | null;
  } | null;
  readonly " $fragmentType": "useShowReturns_item";
};
export type useShowReturns_item$key = {
  readonly " $data"?: useShowReturns_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowReturns_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowReturns_item",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "ReturnPolicy",
          "kind": "LinkedField",
          "name": "returnPolicy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "includeEuReturns",
                  "value": true
                },
                {
                  "kind": "Variable",
                  "name": "userCountryCode",
                  "variableName": "userCountryCode"
                }
              ],
              "kind": "ScalarField",
              "name": "returnDays",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f09a43a975869c9080f5a9d9fee0ac2a";

export default node;
